<template>
    <form-input-layout :active="active" :help-item-code="helpItemCode">
        <template slot="caption">
            {{caption}}
        </template>
        <template slot="input">
            <div class="input-container">
                <switch-button inline @selected="selectNegation" v-model="negation" :options="negationOptions"/>
                <inline-switch @selected="selectMode" v-model="conditionMode"
                               :options="conditionModeOptions"/>
                <template v-if="conditionMode == 'range'">
                    <div class="inline-text">
                        from
                    </div>
                    <div class="inline-calendar">

                        <v-date-picker
                            locale="en"
                            v-model="calStartDateValue"
                            @input="handleCalendar('startDateValue', 'calStartDateValue',$event)"
                            :popover="{visibility: 'click', placement: 'bottom'}">
                            <template v-slot="{ inputValue, inputEvents }">
                                <icon v-on="inputEvents" :icon="['fal', 'calendar']"/>
                            </template>
                        </v-date-picker>

                    </div>
                    <input v-model="startDateValue" :class="{ 'input-component': true, 'active': active}"
                           :disabled="disabled" @input="handleInput"/>

                    <div class="inline-text">
                        to
                    </div>
                    <div class="inline-calendar">

                        <v-date-picker
                            locale="en"
                            v-model="calEndDateValue"
                            @input="handleCalendar('endDateValue', 'calEndDateValue',$event)"
                            :popover="{visibility: 'click', placement: 'bottom'}">
                            <template v-slot="{ inputValue, inputEvents }">
                                <icon v-on="inputEvents" :icon="['fal', 'calendar']"/>
                            </template>
                        </v-date-picker>


                    </div>
                    <input v-model="endDateValue" :class="{ 'input-component': true, 'active': active}"
                           :disabled="disabled" @input="handleInput"/>

                </template>
                <template v-else-if="conditionMode == 'empty'">
                    <div class="inline-text">
                        N/A
                    </div>
                </template>
                <template v-else>
                    <div class="inline-calendar">

                        <v-date-picker
                            locale="en"
                            v-model="calStartDateValue"
                            @input="handleCalendar('startDateValue', 'calStartDateValue',$event)"
                            :popover="{visibility: 'click', placement: 'bottom'}">
                            <template v-slot="{ inputValue, inputEvents }">
                                <icon v-on="inputEvents" :icon="['fal', 'calendar']"/>
                            </template>
                        </v-date-picker>

                    </div>
                    <input v-model="startDateValue" :class="{ 'input-component': true, 'active': active}"
                           :disabled="disabled" @input="handleInput"/>
                </template>
            </div>
        </template>
    </form-input-layout>
</template>

<script>
    import FormInputLayout from "../form/FormInputLayout";
    import SwitchButton from "../button/SwitchButton";
    import SimpleButton from "../button/SimpleButton";
    import InlineSwitch from "../button/InlineSwitch";

    export default {
        name: "FilterInputDate",
        components: {InlineSwitch, SimpleButton, SwitchButton, FormInputLayout},
        props: {
            helpItemCode: String,
            active: Boolean,
            caption: String,
            disabled: Boolean,
            queryItem: String,
            value: [Object, Date]
        },
        computed: {
            conditionModeOptions() {
                return [{caption: '=', value: 'eq'}, {caption: '<', value: 'lt'}, {
                    caption: '>',
                    value: 'gt'
                }, {caption: '~', value: 'around'}, {caption: this.$t('searchQuery.range'), value: 'range'}, { caption: this.$t('searchQuery.isEmpty'), value: "empty"}]
            },
            negationOptions() {
                return [{caption: this.$t("searchQuery.not"), value: "not"}];
            }
        },
        data: function () {
            return {
                startDateValue: "",
                calStartDateValue: "",
                endDateValue: "",
                calEndDateValue: "",
                conditionMode: "",
                negation: "",
                dateAttributes: [
                    {
                        key: 'today',
                        highlight: {
                            style: {
                                borderColor: '#3D6431', //accent-color
                                borderWidth: '2px',
                                borderStyle: 'solid',
                            },

                        },
                        dates: new Date(),
                        order: 100
                    },
                ],
                today: this.$formats.formatDate(new Date()),
            }
        },
        methods: {
            selectNegation(negValue) {
                this.negation = negValue;
                this.$emit('input', this.transformResult());
            },
            selectMode(mode) {
                this.conditionMode = mode;
                this.$emit('input', this.transformResult());
            },
            handleInput() {
                let dateInput = this.$moment(this.startDateValue, 'D.M.YYYY', true);
                if(dateInput.toISOString() != null) {
                    this.calStartDateValue = dateInput.toDate();
                }
                dateInput = this.$moment(this.endDateValue, 'D.M.YYYY', true);
                if(dateInput.toISOString() != null) {
                    this.calEndDateValue = dateInput.toDate();
                }
                this.$emit('input', this.transformResult());
            },
            handleCalendar(kind, calKind, data) {
                this[kind] = this.$moment(data.toISOString()).format('D.M.YYYY');
                this[calKind] = data;
                this.$emit('input', this.transformResult());
            },
            transformResult() {
                let translatedStartDate = this.$moment(this.startDateValue, 'D.M.YYYY', true).toISOString(true);
                let translatedEndDate = "";
                if(this.conditionMode == 'empty') {
                    return {
                        type: 'date',
                        operator: this.conditionMode,
                        value: "",
                        negation: this.negation === "not"
                    }
                }
                if (this.conditionMode == 'range') {
                    translatedEndDate = this.$moment(this.endDateValue, 'D.M.YYYY', true).toISOString(true);
                }
                if (this.startDateValue != "" && this.startDateValue != null && this.conditionMode != "") {
                    return {
                        type: 'date',
                        operator: this.conditionMode,
                        value: this.conditionMode == 'range' ?
                            (translatedStartDate == null ? this.startDateValue : translatedStartDate.split(".")[0]) + ";" + (translatedEndDate == null ? this.endDateValue : translatedEndDate.split(".")[0]) :
                            translatedStartDate == null ? this.startDateValue : translatedStartDate.split(".")[0],
                        negation: this.negation === "not"
                    };
                } else {
                    return undefined;
                }

            }
        },
        watch: {
            value: {
                handler(newVal, oldVal) {
                    if (newVal != undefined && newVal.value != undefined && newVal.operator != "") {
                        this.conditionMode = newVal.operator;
                        this.negation = newVal.negation || newVal.negation == 'not' ? "not" : "";
                        if (this.conditionMode == 'range') {
                            let vals = newVal.value.split(";");
                            let translatedVal = this.$moment(vals[0], "YYYY-MM-DDTHH:mm:SS", true)
                            this.startDateValue = translatedVal.toISOString() == null ? vals[0] : translatedVal.format("D.M.YYYY");
                            if (vals.length == 2 && vals[1] != null) {
                                let translatedVal = this.$moment(vals[1], "YYYY-MM-DDTHH:mm:SS", true);
                                this.endDateValue = translatedVal.toISOString() == null ? vals[1] : translatedVal.format("D.M.YYYY");
                            } else
                                this.endDateValue = ""
                        } else {
                            let translatedStartDate = this.$moment(newVal.value, "YYYY-MM-DDTHH:mm:SS", true)
                            this.startDateValue = translatedStartDate.toISOString() == null ? newVal.value : translatedStartDate.format("D.M.YYYY");
                        }
                    } else {
                        this.conditionMode = "";
                        this.startDateValue = "";
                        this.endDateValue = "";
                        this.negation = "";
                    }

                },
                immediate: true
            }

        }
    }
</script>

<style scoped lang="scss">
    .input-container {
        display: flex;
        flex-flow: row;
        white-space: nowrap;
        border-bottom: 1px solid var(--input-border-color);
        background-color: var(--input-background-color);
    }

    .input-component {
        background-color: transparent;
        border: none;
        color: var(--input-font-color);
        padding: 5px 10px 5px 10px;
        outline: none;
        width: 100%;
        font-family: Source Sans Pro;
    }

    .active {
        color: var(--input-active-font-color);
        background-color: var(--input-active-background-color);
        border: 1px solid var(--input-active-border-color);
    }

    .required {
        color: var(--accent-color);
    }

    .inline-text {
        display: flex;
        padding: 5px 5px 5px 5px;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }

    .inline-calendar {
        display: flex;
        padding: 5px 5px 5px 10px;
        align-content: center;
        align-items: center;
        justify-content: center;
        justify-items: center;
    }
</style>